// removed by extract-text-webpack-plugin
module.exports = {"Department":"Tile__Department__1glGj","Subject":"Tile__Subject__1OGdu"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Contents/Lists/Tile/Tile.css
// module id = 69
// module chunks = 0